export default class ProductFeatureVisiblity {
    generalPayeeSettings = false;
    depositBankSettings = false;
    depositCardSettings = false;
    depositPaymentOrderSettings = false;
    depositInterestSettings = false;
    depositOverdraftSettings = false;
    depositOverdraftInterestSettings = false;
    depositFixedTermSettings = false;
    depositFixedTermMaturitySettings = false;
    depositInstantAccessSettings = false;
    depositCoolingOffSettings = false;
    lendingBankSettings = false;
    lendingCardSettings = false;
    lendingInterestSettings = false;
    lendingScheduleSettings = false;
    lendingTermSettings = false;
    lendingDynamicTermSettings = false;
    lendingRevolvingCreditSettings = false;
    lendingRepaymentPlanSettings = false;
    lendingRepaymentPlanInterestSettings = false;
}